/**
 * Created by Ning Jiang on 2023-08-30.
 */
import {WinPresentationController} from "../../WinPresentationController";
import {DevilsCrossRoad} from "../../../DevilsCrossRoad";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {BelowStakeWinRestriction} from "../../../server/BelowStakeWinRestriction";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {gsap, TimelineLite} from "gsap";
import {DevilsCrossRoadSound} from "../../../sound/DevilsCrossRoadSound";

export class TotalWinController extends WinPresentationController {

    private _mainTimeline:TimelineLite | null;
    private _belowStakeWinRestriction:boolean;
    private _winLevel:number;
    private _winSoundName:string;

    constructor() {
        super("TotalWinController", true);
    }

    protected hasWin():boolean {
        return DevilsCrossRoad.model.gameData.nextMode === GameMode.NORMAL &&
            DevilsCrossRoad.model.gameData.accumulatedRoundWin > 0 &&
            DevilsCrossRoad.model.totalWinRatioConfig!.bigWinLevel === -1;
    }

    protected async createWinAnimation():Promise<any> {
        this._belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowPlayedBetValue();
        this._winLevel = DevilsCrossRoad.model.totalWinRatioConfig?.winLevel!;
        const tl = gsap.timeline();
        tl.add(() => {DevilsCrossRoad.multipliers.dimAllMultipliers()});
        tl.add(this.getWinCountUpAnimation());
        this._mainTimeline = tl;
        if(tl.totalDuration() > 0) {
            await Promise.resolve(tl);
        }
        this._mainTimeline = null;
        this._winSoundName = "";
    }

    protected getWinCountUpAnimation():TimelineLite {
        const tl = gsap.timeline();
        if(!this._belowStakeWinRestriction) {
            tl.add([
                DevilsCrossRoad.totalWinCountUp.getCountUpAnimation(0, DevilsCrossRoad.model.data.accumulatedRoundWin, DevilsCrossRoad.model.totalWinRatioConfig!.duration),
                () => {
                    this._winSoundName = DevilsCrossRoadSound.getWinSoundName(this._winLevel);
                    DevilsCrossRoadSound.soundPlayer.playTrack({name : this._winSoundName});
                }
            ]);
        }
        tl.add(() => {
            SlotGame.keypadPlugin.setWin(DevilsCrossRoad.model.data.accumulatedRoundWin, true, BelowStakeWinRestriction.isWinBelowStake());
            if(!this._belowStakeWinRestriction) {
                const endSound = DevilsCrossRoadSound.getWinEndSoundName(this._winLevel);
                if(endSound.length > 0) {
                    DevilsCrossRoadSound.soundPlayer.playTrack({name : endSound});
                }
            }
        });
        if(DevilsCrossRoad.model.totalWinRatioConfig?.ratio! > 1) {
            tl.add(() => {}, `+=0.5`);
        }

        return tl;
    }

    protected skip() {
        this._mainTimeline?.progress(1);
        if(this._winLevel > 1) {
            DevilsCrossRoadSound.soundPlayer.stopTrack(this._winSoundName);
        }
    }
}